@use '../../assets/styles/variables.scss' as vars;

.need {
  border-top: solid 1px vars.$white;
  margin-top: 2rem;

  &:first-child {
    border-top: none;
    margin-top: 0;
  }
}

.need__gallery {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.need__links {
  display: flex;
  gap: 16px;
}
